// extracted by mini-css-extract-plugin
export default {"register":"register_register__u0eSF","input-row":"register_input-row__h21ki"};